<form [formGroup]="auditTrailForm" class="ledger-filter-form">
  <div class="flexbox aff-info">
    <div class="flexbox aff-info-inner w-100">

      <div class="flexbox">

        <div class="text-input-fiel">
          <ng-container *ngIf="isLocaleDateFormat">
            <input
              class="input-ui"
              searchtabindex="1"
              formControlName="start_date"
              id="date"
              type="date"
              [min]="minDate"
              [max]="maxDate"
              [ngClass]="{
                'error-box': !auditTrailForm.controls.start_date.valid
              }"
            />
          </ng-container>

          <ng-container *ngIf="!isLocaleDateFormat && auditTrailForm.controls.start_date">
            <app-date-time-input
              formControlName="start_date"
              [dateFormat]="dateFormat"
              [minDate]="minDate"
              [maxDate]="maxDate"
              [fieldController]="auditTrailForm.controls.start_date"
              class="new-date-input"
              classes="inv-date-input"
              tIndex="1">
            </app-date-time-input>
          </ng-container>

          <label>Starting Date</label>
        </div>

        <div class="text-input-fiel mr-0">
          <ng-container *ngIf="isLocaleDateFormat">
            <input
              class="input-ui"
              searchtabindex="2"
              formControlName="end_date"
              id="date"
              type="date"
              [min]="minDate"
              [max]="maxDate"
              [ngClass]="{
                'error-box': !auditTrailForm.controls.end_date.valid
              }"
            />
          </ng-container>

          <ng-container *ngIf="!isLocaleDateFormat && auditTrailForm.controls.end_date">
            <app-date-time-input
              formControlName="end_date"
              [dateFormat]="dateFormat"
              [minDate]="minDate"
              [maxDate]="maxDate"
              [fieldController]="auditTrailForm.controls.end_date"
              class="new-date-input"
              classes="inv-date-input"
              tIndex="2">
            </app-date-time-input>
          </ng-container>

          <label for="to_date">Ending Date</label>
        </div>

      </div>

      <div class="d-flex mt-5 justify-content-center">
        <div class="input-fiel">
          <button
            id="submitSearchForm"
            type="button"
            class="btn-style bg-purple mr-3"
            data-dismiss="modal"
            searchtabindex="3"
            #searchButton
            (keyup.enter)="clickSearchButton()"
            [disabled]="auditTrailForm.invalid"
            (click)="search(auditTrailForm.value)">
            Search
          </button>

          <button
            type="button"
            class="btn-style bg-green"
            id="resetSearchForm"
            (click)="reset()">
            RESET
          </button>
        </div>
      </div>

    </div>
  </div>
</form>